import React from 'react';
import axios from 'axios';

// Function to Base64 encode the content
const base64Encode = (str) => {
    return btoa(unescape(encodeURIComponent(str)));
};

const GitHubFileUploader = ({ jsonData, fileName }) => {
    const uploadFileToGitHub = async () => {
        try {
            const token = window.prompt("Please enter your GitHub Personal Access Token:");
            if (!token) {
                alert('Token is required to proceed!');
                return;
            }

            const owner = 'SenyaGur';
            const repo = 'ains-personal-website';
            const path = `src/information/${fileName}`; // Changed to test.json
            const branch = 'master';

            // Serialize the jsonData parameter into a JSON string
            const jsonContent = JSON.stringify(jsonData, null, 2);

            // Base64 encode the JSON content
            const encodedContent = base64Encode(jsonContent);

            const apiUrl = `https://api.github.com/repos/${owner}/${repo}/contents/${path}`;

            let sha = null;

            // Step 1: Check if the file already exists
            try {
                const fileResponse = await axios.get(apiUrl, {
                    headers: {
                        Authorization: `token ${token}`,
                    },
                });
                sha = fileResponse.data.sha; // Get the sha if file exists
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    console.log('File does not exist, creating a new one.');
                } else {
                    throw error;
                }
            }

            // Step 2: Create or Update the file
            const body = {
                message: sha ? `Update ${fileName}` : `Add ${fileName}`, // Commit message
                content: encodedContent,
                branch: branch,
            };

            if (sha) {
                body.sha = sha; // Include the sha for updating the file
            }

            const response = await axios.put(apiUrl, body, {
                headers: {
                    Authorization: `token ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 201 || response.status === 200) {
                alert('File uploaded successfully!');
            } else {
                alert(`Something went wrong! Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Error uploading the file:', error);
            alert('Error uploading the file. Please check the console for more details.');
        }
    };

    return (
        <div>
            <button onClick={uploadFileToGitHub}>Upload JSON File</button>
        </div>
    );
};

export default GitHubFileUploader;
